var exports = {
  "kL": "GuildWebhooksTab.module__container___a2VRaz",
  "wx": "GuildWebhooksTab.module__header___a2VRaz",
  "DD": "GuildWebhooksTab.module__title___a2VRaz",
  "VA": "GuildWebhooksTab.module__subtitle___a2VRaz",
  "lm": "GuildWebhooksTab.module__notice___a2VRaz",
  "et": "GuildWebhooksTab.module__infoBox___a2VRaz",
  "dc": "GuildWebhooksTab.module__spinnerContainer___a2VRaz",
  "g": "GuildWebhooksTab.module__webhookList___a2VRaz",
};

module.exports = exports;
